var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.2215C19 13.7097 18.8628 13.1979 18.5885 12.7226L11.6614 1.27957C11.1813 0.475269 10.3582 0 9.50092 0C8.60931 0 7.82058 0.475269 7.34048 1.27957L0.41335 12.7591C-0.101041 13.6 -0.135334 14.6968 0.310472 15.5742C0.756277 16.4516 1.64789 17 2.57379 17H16.3938C17.354 17 18.2113 16.4516 18.6571 15.5742C18.8971 15.1355 19 14.6968 19 14.2215Z",
    fill: "#FBDB7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.2215C19 13.7097 18.8628 13.1979 18.5885 12.7226L11.6614 1.27957C11.1813 0.475269 10.3582 0 9.50092 0C8.60931 0 7.82058 0.475269 7.34048 1.27957L0.41335 12.7591C-0.101041 13.6 -0.135334 14.6968 0.310472 15.5742C0.756277 16.4516 1.64789 17 2.57379 17H16.3938C17.354 17 18.2113 16.4516 18.6571 15.5742C18.8971 15.1355 19 14.6968 19 14.2215ZM17.6283 14.9527C17.3882 15.428 16.9081 15.7204 16.3938 15.7204H2.60808C2.09369 15.7204 1.61359 15.428 1.37355 14.9527C1.1335 14.4774 1.1335 13.8925 1.40784 13.4172L8.30067 1.93763C8.57502 1.49893 8.98653 1.24301 9.46663 1.24301C9.94672 1.24301 10.3925 1.49893 10.6326 1.93763L17.5254 13.4172C17.6626 13.6731 17.7312 13.929 17.7312 14.2215C17.7998 14.4774 17.7655 14.7333 17.6283 14.9527Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2538 11.125H8.80859V12.639H10.2538V11.125Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2538 5H8.80859V9.85161H10.2538V5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0667ea7588d47900fd33871094e360bf.svg";
export { ForwardRef as ReactComponent };